import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import css from './index.module.scss';
import Button from '../Button';
import Overlay from '../Overlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var AlertOverlay = /*#__PURE__*/function (_Component) {
  _inherits(AlertOverlay, _Component);

  var _super = _createSuper(AlertOverlay);

  function AlertOverlay(props) {
    var _this;

    _classCallCheck(this, AlertOverlay);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "hideOverlay", function () {
      _this.setState({
        on: false
      });
    });

    _this.state = {
      on: false
    };
    _this.timeout = {};
    return _this;
  }

  _createClass(AlertOverlay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.timeout = setTimeout(function () {
        _this2.setState({
          on: true
        });
      }, 250);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "getOverlayNode",
    value: function getOverlayNode() {
      var _this$props = this.props,
          message = _this$props.message,
          title = _this$props.title;
      var on = this.state.on;
      return /*#__PURE__*/_jsx(Overlay, {
        ariaLabelledBy: "alert-title",
        ariaDescribedBy: "alert-description",
        onHide: this.hideOverlay,
        on: on,
        children: /*#__PURE__*/_jsxs("section", {
          className: cc([css.root, _defineProperty({}, css.on, on)]),
          children: [/*#__PURE__*/_jsx("h2", {
            className: css.title,
            id: "alert-title",
            children: title
          }), /*#__PURE__*/_jsx("p", {
            className: css.copy,
            dangerouslySetInnerHTML: {
              __html: message
            },
            id: "alert-description"
          }), /*#__PURE__*/_jsx("div", {
            className: css.actions,
            children: /*#__PURE__*/_jsx(Button, {
              className: "overlay-focus",
              onClick: this.hideOverlay,
              children: "Okay"
            })
          })]
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsx("div", {
        children: this.getOverlayNode()
      });
    }
  }]);

  return AlertOverlay;
}(Component);

AlertOverlay.displayName = 'AlertOverlay';
AlertOverlay.propTypes = {
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
export default AlertOverlay;